export default __webpack_public_path__ + "43c10f8c52f589fbb9845711bd8ece03.png";